export default function NotFoundPage() {
  return 404;
}
